module.exports = __webpack_public_path__ + "static/media/Slayers.9892afda.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/about/Slayers.png
// module id = 242
// module chunks = 0